import Vue from 'vue';

const eventBus = {};

eventBus.install = function(Vue) {
    Vue.prototype.$bus = new Vue();
};

Vue.use(eventBus);



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/global-event-bus.js